<template>
    <div id="app">
      <!-- 头部 -->
      <HeaderTopView v-bind:num="num" @childFn="parentFn($event)"></HeaderTopView>
      <HeaderView></HeaderView>
      <NavView></NavView>
      <section class="banner_div word">
        <div id="b-map" ref="allmap"></div>
        <div class="img-box">
          <div class="boxing boxing1">
            <div class="img">
              <img src="@/assets/images/ct1.png">
            </div>
            <div class="font1">联系方式</div>
            <div class="font2 line1">0317-8345726 / 13408091666</div>
            <div class="font2">邮箱0317@163.com</div>
          </div>
          <div class="boxing boxing2">
            <div class="img">
              <img src="@/assets/images/ct2.png">
            </div>
            <div class="font1">工作时间</div>
            <div class="font2">上班时间：周一至周五 / 10am-6pm</div>
          </div>
          <div class="boxing">
            <div class="img">
              <img src="@/assets/images/ct3.png">
            </div>
            <div class="font1">公司地址</div>
            <div class="font2 line1">北京市北京经济技术开发区经海五路58号</div>
            <div class="font2">生产基地：河北省泊头市富镇开发区</div>
          </div>
        </div>

        <div class="leaving-msg">
          <div class="title">用户留言</div>
          <div class="lines">
            <i></i><i></i><i></i>
          </div>
          <div class="inps">
            <input class="inp" placeholder="Name">
            <input class="inp" placeholder="Mail">
            <input class="inp" placeholder="country">
          </div>
          <textarea placeholder="Message"></textarea>
          <div class="btns">
            <button>send comment</button>
            <span>Clear</span>
          </div>
        </div>
      </section>
      <!-- 底部 -->
      <Footer></Footer>



    </div>
</template>

<script>
  import HeaderTopView from '@/components/assembly/HeaderTop.vue';//头部模块
  import HeaderView from '@/components/assembly/Header.vue';//头部模块
  import NavView from '@/components/assembly/Nav.vue';//导航模块
  import Footer from '@/components/assembly/Footer.vue';//导航模块
    export default {
        name: "ContactUs",
      data() {
        return {
          num: 1,
        }
      },
      methods:{
        map () {
          let map = new window.BMap.Map(this.$refs.allmap) ;// 创建Map实例
          map.centerAndZoom(new window.BMap.Point(116.404, 39.915), 11) ;// 初始化地图,设置中心点坐标和地图级别
          map.addControl(new window.BMap.MapTypeControl({ // 添加地图类型控件
            mapTypes: [
              window.BMAP_NORMAL_MAP,
              window.BMAP_HYBRID_MAP
            ]
          }));
          map.setCurrentCity('北京') ;// 设置地图显示的城市 此项是必须设置的
          map.enableScrollWheelZoom(true)// 开启鼠标滚轮缩放
        }

      },
      components: {
        HeaderView, NavView, HeaderTopView,Footer
      },
      mounted() {
          this.map()
      }
    }
</script>

<style scoped>
  section{
    margin-bottom: 97px;
  }
#b-map{
  width: 100%;
  height: 400px;
}
  .banner_div{
    padding-top:48px;
  }
  .img-box{
    padding:48px  90px 0 145px;
    display: flex;
    justify-content: space-between;
  }
  .boxing{
    align-items: center;
    display: flex;
    flex-direction: column;
  }
  .img{
    width: 80px;
    height: 80px;
  }
  img{
    width: 100%;
    height: 100%;
    display: block;
  }
  .font1{
    font-size: 16px;
    color: #666;
    margin-top: 14px;
    margin-bottom: 35px;
  }
  .font2{
    font-size: 14px;
    color: #999;
  }
  .line1{
    margin-bottom: 16px;
  }
  .leaving-msg{
    margin-top: 85px;

  }
  .title{
    font-size: 24px;
    color: #252525;
  }
  .lines{
  margin-bottom: 44px;
  }
.lines>i{
  display: inline-block;
  width: 35px;
  height: 1px;
  background:#D8D8D8;
}
.lines>i:nth-child(2n){
  background: #262626;
}
.inps{
  display: flex;
  justify-content: space-between;
}
  .inp{
    width: 380px;
    height: 40px;
    background:transparent;
    border: 1px solid #D3D3D3;
    padding-left: 15px;
    box-sizing: border-box;
  }
textarea{
  width: 100%;
  height: 150px;
  border: 1px solid #D3D3D3;
  padding: 15px 31px;
  box-sizing: border-box;
  background: transparent;
  resize: none;
  margin-top: 19px;
}
button{
  background: #0090FF;
  color: #fff;
  width: 150px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 2px;
}
.btns{
  display: flex;
  justify-content: space-between;
  margin-top: 19px;
}
  .btns span{
    font-size: 13px;
    color: #0090FF;
    padding-top: 11px;
  }
</style>



// WEBPACK FOOTER //
// src/components/contactUs/ContactUs.vue